export const CloseIcon: React.FC<React.SVGAttributes<{}>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="white" />
    <path
      d="M18 12L12 18"
      stroke="#5B5B5F"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 12L18 18"
      stroke="#5B5B5F"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#E5E5E5" />
  </svg>
);

export const CloseIconNew: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      stroke="currentColor"
      fill="none"
      strokeWidth={0}
      viewBox="0 0 15 15"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.854 2.854a.5.5 0 00-.708-.708L7.5 6.793 2.854 2.146a.5.5 0 10-.708.708L6.793 7.5l-4.647 4.646a.5.5 0 00.708.708L7.5 8.207l4.646 4.647a.5.5 0 00.708-.708L8.207 7.5l4.647-4.646z"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
};

export const CloseIconMinified: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      {...props}
    >
      <circle
        cx="11.0215"
        cy="10.4997"
        r="7.40956"
        transform="rotate(45 11.0215 10.4997)"
        stroke="#5B5B5F"
      />
      <path
        d="M13.4961 8.0249L8.54635 12.9746"
        stroke="#5B5B5F"
        strokeLinecap="round"
      />
      <path
        d="M13.4961 12.9746L8.54635 8.02486"
        stroke="#5B5B5F"
        strokeLinecap="round"
      />
    </svg>
  );
};
